import anaUtils from 'analytics/utils';
import urlUtils from 'utils/Url';
import { Image } from 'components/ui';
import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import helpersUtils from 'utils/Helpers';

const { deferTaskExecution } = helpersUtils;

const { getLink } = urlUtils;

function Logo() {
    const onLogoClick = () => {
        deferTaskExecution(() => {
            anaUtils.setNextPageData({
                navigationInfo: anaUtils.buildNavPath(['top nav', 'sephora icon'])
            });
        });
    };

    return (
        <a
            href={getLink('/')}
            onClick={onLogoClick}
            css={{ display: 'block' }}
        >
            <Image
                display='block'
                alt='Sephora'
                src='/img/ufe/logo.svg'
                disableLazyLoad={true}
                width={[85, 216]}
                height={[11, 28]}
                data-at={Sephora.debug.dataAt('sephora_logo_ref')}
            />
        </a>
    );
}

export default wrapFunctionalComponent(Logo, 'Logo');
